import { SecureKeypad } from "components"
import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import Lib from 'library'

const Login = () => {

	const App = useApp()
	const navigate = useNavigate()
	const location = useLocation()
	const [id, setId] = useState(location.state?.id)

	const callback = async module => {
		const info = module.get_sessionInfo()
		await Lib.post(`/api/data/crtf/view/${id}`, {
			secId: info.sessionId,
			secToken: info.secToken,
			secInput: info.input,
		}, data => {
			console.log(data)
			navigate("/certificate", {
				state: {
					sno: id,
					data: data
				}	
			})
		}, error => {
			if(error.code === "E001"){
				App.showAlert('비밀번호가 맞지 않습니다.')
			} else if (error.code === "E002") {
				App.showAlert('열람가능시간이 만료되었습니다.')
			} else if (error.code === "E003") {
				App.showAlert('탈퇴한 회원의 증명서입니다.')
			} else if (error.code === "E004") {
				App.showAlert('비밀번호를 5회이상 잘못입력하셨습니다.')
			} else {
				App.showAlert('증명서가 존재하지 않습니다.')
			}
		})
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: null,
			right: <i className="icon_close" onClick={() => {
				navigate("/")
			}} />
		}
)
		App.setShowNav(false)
		App.setAppBg("#ffffff")

		console.log({location})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="page flex-column">
			<input type="hidden" id="passInput" />
			<SecureKeypad input="passInput" title="공유 받은 비밀번호 6자리를 입력하세요." callback={callback} autoClose={false} />
		</div>
	)
}

export default Login
